const isEmpty = (str) => !str.trim().length;

const isHidden = (el) => {
  const style = window.getComputedStyle(el);
  return style.display === 'none' || style.visibility === 'hidden';
};

const isVisible = (el) =>
  el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;

const scrollToElement = (el) => {
  if (el.length) {
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: el.offsetTop,
    });
  }
};

const isCheckbox = (el) => el.type && el.type === 'checkbox';

export default { isEmpty, isHidden, isVisible, scrollToElement, isCheckbox };
